<template>
    <div>
        <Chart :type="props.chartType" :data="chartData" :options="chartOptions" class="h-20rem" />
    </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue';
import { useMetricDataStore } from '../../../../../store/metric/metricData';

const metricDataStore = useMetricDataStore();

const props = defineProps({
    jsonData: {
        type: Array,
        default: null,
    },
    chartType: {
        type: String,
    },
});


/** Generic Properties */
const chartData = ref({
    labels: null,
    datasets: [],
});
const chartOptions = ref();

onMounted(() => {
    loadChartData();
});

const loadChartData = async () => {
    chartData.value = await setChartData();
    chartOptions.value = setChartOptions();
};

const setChartData = async () => {
    const documentStyle = getComputedStyle(document.documentElement);
    // load chart datasets
    const datasets = await metricDataStore.getDSBarChartDatasets(props.jsonData, documentStyle, props.chartType === 'line');
    return {
        // Group By acts like x-axis which will be the initial labels
        labels: datasets.chartLabels,
        datasets: datasets.chartData,
    };
};

const setChartOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    const options = {
        indexAxis: 'x',
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        plugins: {
            legend: {
                labels: {
                    usePointStyle: props.chartType === 'pie',
                    fontColor: textColor,
                },
            },
        },
    };

    // scales are only for bar and line charts,
    if (props.chartType !== 'pie') {
        options.scales = {
            x: {
                ticks: {
                    color: textColorSecondary,
                    font: {
                        weight: 500,
                    },
                },
                grid: {
                    display: false,
                    drawBorder: false,
                },
            },
            y: {
                ticks: {
                    color: textColorSecondary,
                },
                grid: {
                    color: surfaceBorder,
                    drawBorder: false,
                },
            },
        };
    }
    return options;
};
</script>
